var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"component",staticClass:"icon-button",class:_vm.classObject,attrs:{"href":_vm.href,"to":_vm.to,"target":_vm.target},on:{"click":_vm.click}},[_c('i',{staticClass:"material-icons"},[_vm._v(_vm._s(_vm.icon))])])}
var staticRenderFns = []

export { render, staticRenderFns }